import { useQuery, useQueryClient, useMutation, useSuspenseQuery } from "@tanstack/react-query";

import { api, type ProjectRow } from "@/lib/api";
import { qk } from "@/lib/queryKeys";

export function useProjects(initialData?: ProjectRow[] | null, options?: { enabled?: boolean; orgId?: string | null }) {
  const orgId = options?.orgId ?? null;
  return useQuery({
    queryKey: orgId ? qk.projectsByOrg(orgId) : qk.projects,
    queryFn: () => api.projects.list(orgId),
    initialData: initialData ?? undefined,
    initialDataUpdatedAt: initialData ? Date.now() : undefined,
    enabled: options?.enabled ?? true,
  });
}

export function useSuspenseProjects(options?: { orgId?: string | null }) {
  const orgId = options?.orgId ?? null;
  return useSuspenseQuery({
    queryKey: orgId ? qk.projectsByOrg(orgId) : qk.projects,
    queryFn: () => api.projects.list(orgId),
  });
}

export function useProjectCreateMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof api.projects.create>[0]) =>
      api.projects.create(body),
    onSuccess: (_data, body) => {
      void qc.invalidateQueries({ queryKey: qk.projects });
      if (body.org_id) {
        void qc.invalidateQueries({ queryKey: qk.projectsByOrg(body.org_id) });
      }
    },
  });
}
